import script from "./valid.vue?vue&type=script&setup=true&lang=ts"
export * from "./valid.vue?vue&type=script&setup=true&lang=ts"

import "./valid.vue?vue&type=style&index=0&id=47e4c34c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e4c34c"]])

export default __exports__